//親のulを取得
let ul =  document.querySelector('select[name="sort_by"]');
//削除したいn番めの要素を取得
let li3 = ul.children[2];
let li4 = ul.children[3];
let li7 = ul.children[6];
//削除
ul.removeChild(li3);
ul.removeChild(li4);
ul.removeChild(li7);

//カゴがからの時は注意書きを削除
if( element.classList.contains('cart--empty-cart') == true ){
  let list_element = document.getElementById("shopify-section-template--17418669031666__advanced_layout_custom_html_VQyKQm");
list_element.remove();
}